import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// id: the section's own address, so a link can land on it (privacy#notice-at-collection).
export const Paragraph = ({ header, id, children }) => {
  return (
    <React.Fragment>
      <h5 id={id}>
        {header}
      </h5>
      <div>
        {children}
      </div>
    </React.Fragment>
  )
}

// Brings the section named after # into view once the page has drawn it. The browser
// tries only at load, before this page exists, so a link from another site would
// otherwise open at the top.
export const useScrollToSection = () => {
  const { hash } = useLocation()
  useEffect(() => {
    if (!hash) return
    const el = document.getElementById(decodeURIComponent(hash.slice(1)))
    if (el && el.scrollIntoView) el.scrollIntoView({ block: 'start' })
  }, [hash])
}
